import React from 'react';
import NormalConComponent from '@/page/conversation/NormalConComponent';

export default function ExternalPage() {
    return (
        <NormalConComponent
            title={'外部会话查询'}
            receiveTabs={[
                {name: '客户', key: 1},
                {name: '外部群聊', key: 4},
            ]}
            sendType={0}
        />
    );
}
